// สถานะการหุบ/กางของแถบซ้าย — เป็น state ของ UI ล้วน ๆ จึงอยู่ใน Zustand ไม่ใช่ Redux
//
// คีย์ใน localStorage ต้องเหมือนของเดิมทุกตัวอักษร ผู้ใช้ที่เคยหุบเมนูไว้บนหน้าเก่า
// จะได้เห็นเหมือนเดิมเมื่อเปิดหน้าใหม่ (ช่วงนี้ยังสลับไปมาได้ทั้งสองหน้า)
import { create } from "zustand";

const KEY_COLLAPSED = "sidebar-collapsed";
const KEY_MENUS = "side-collapsed-menus";

function readCollapsedMenus(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY_MENUS) ?? "null");
    return Array.isArray(v) ? (v as string[]) : [];
  } catch {
    return [];
  }
}

type SidebarState = {
  collapsed: boolean;
  /** เก็บเฉพาะ "อันที่ผู้ใช้หุบเอง" — เมนูใหม่ที่เพิ่มมาภายหลังจึงกางให้เองโดยไม่ต้องตั้งค่า */
  collapsedMenus: string[];
  toggleCollapsed: () => void;
  expand: () => void;
  toggleMenu: (menuId: string) => void;
};

export const useSidebarStore = create<SidebarState>((set, get) => ({
  collapsed: localStorage.getItem(KEY_COLLAPSED) === "1",
  collapsedMenus: readCollapsedMenus(),

  toggleCollapsed() {
    const next = !get().collapsed;
    localStorage.setItem(KEY_COLLAPSED, next ? "1" : "0");
    set({ collapsed: next });
  },

  expand() {
    if (!get().collapsed) return;
    localStorage.setItem(KEY_COLLAPSED, "0");
    set({ collapsed: false });
  },

  toggleMenu(menuId) {
    const set2 = new Set(get().collapsedMenus);
    if (set2.has(menuId)) set2.delete(menuId);
    else set2.add(menuId);
    const list = [...set2];
    localStorage.setItem(KEY_MENUS, JSON.stringify(list));
    set({ collapsedMenus: list });
  },
}));
